import {
  EyeOutlined,
  ReloadOutlined,
  RightCircleTwoTone
} from "@ant-design/icons";
import {
  ProCard,
  ProTable
} from "@ant-design/pro-components";
import {
  Button,
  Card,
  Col,
  Divider,
  Empty,
  Form,
  Grid,
  Input,
  Modal,
  Popover,
  QRCode,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Tooltip,
  Typography,
  message
} from "antd";
import React, { useEffect, useState } from "react";

import Title from "antd/es/typography/Title";
import moment from "moment";
import { useAuth } from "../../hooks/useAuth";
import { api } from "../../services/api";

const { useBreakpoint } = Grid;
const { Text } = Typography;
const payments = {
  pix: "PIX",
  credit_card: "Cartão de Crédito",
  bank_slip: "Boleto",
  cash: "Dinheiro",
};

const colors = {
  isenta: 'orange',
  paga: "green",
  pendente: "orange",
  cancelada: "red",
  vencida: "red",
  expirado: "red",
}


const CreditCardForm = ({ form, data, loading }) => {
  const [creditCardValues, setCreditCardValues] = useState({
    credit_card_number: '',
    credit_card_expiration: '',
    credit_card_verification_value: '',
    credit_card_first_name: '',
    credit_card_last_name: ''
  })
  function limitDecimalsWithoutRounding(val, decimals) {

    let value = Math.round(val * 1000) / 1000
    let parts = value.toString().split(".");
    return parseFloat(parts[0] + "." + parts[1]?.substring(0, decimals));
  }


  const installmentWithoutInterest = (value, portion, discount, onlyNumber = false) => {



    let amount = value - (discount * value) / 100


    const response = amount / portion;


    if (onlyNumber) return response;


    return Intl.NumberFormat("pt-br", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 4,
    }).format(limitDecimalsWithoutRounding(response, 2));

  };


  return <Row gutter={[12, 12]}>



    <Col lg={12} span={24}>
      <Title
        level={4}
        style={{ margin: 0, marginBottom: 12 }}
      >
        Mudar Forma de Pagamento
      </Title>
      <Row gutter={[12, 12]}>
        <Col span={12}>
          <Form.Item
            label="Primeiro nome"
            name="credit_card_first_name"
            rules={[
              {
                required: true,
                message: "Insira o nome do titular do cartão",
              },
            ]}
          >
            <Input
              onChange={(e) => {
                setCreditCardValues(prev => ({ ...prev, credit_card_first_name: e.target.value }))
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Último nome"
            name="credit_card_last_name"
            rules={[
              {
                required: true,
                message: "Insira o último nome do titular do cartão",
              },
            ]}
          >
            <Input
              onChange={(e) => {
                setCreditCardValues(prev => ({ ...prev, credit_card_last_name: e.target.value }))
              }}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="Número do cartão"
            name="credit_card_number"
            rules={[
              {
                required: true,
                message: "Insira o número de cartão",
              },
              {
                validator: async (_, value) => {
                  let formattedValue = value
                    ?.replace(/\D+/g, "")
                    ?.replace(/(\d{4})(\d)/, "$1 $2")
                    ?.replace(/(\d{4})(\d)/, "$1 $2")
                    ?.replace(/(\d{4})(\d)/, "$1 $2")
                    ?.replace(/(\d{4})(\d)/, "$1 $2");

                  setCreditCardValues(prev => ({ ...prev, credit_card_number: formattedValue }))

                  form.setFieldsValue({
                    credit_card_number: formattedValue,
                  });
                },
              },
            ]}
          >
            <Input
              minLength={16}
              maxLength={23}
            />
          </Form.Item>

        </Col>
        <Col span={12}>
          <Form.Item
            label="Validade"
            name="credit_card_expiration"
            rules={[
              {
                required: true,
                message: "Insira a data de expiração",
              },
              {
                validator: async (_, value) => {
                  let formattedValue = value
                    ?.replace(/\D+/g, "")
                    ?.replace(/(\d{2})(\d)/, "$1/$2")


                  let month = formattedValue?.split('/')[0]



                  if (month?.length === 2) {
                    let monthNumber = parseInt(month)
                    if (monthNumber < 1 || monthNumber > 12) {
                      formattedValue = formattedValue.slice(0, 1)
                    }
                  } else if (month?.length === 1) {
                    let monthNumber = parseInt(month)
                    if (monthNumber > 1) {
                      formattedValue = `0${monthNumber}/`
                    }

                  }



                  let year = formattedValue?.split('/')[1]
                  if (year?.length === 2) {
                    let yearNumber = parseInt(year)
                    let currentYear = new Date().getFullYear().toString().slice(2)
                    if (yearNumber < currentYear) {
                      return Promise.reject('Ano inválido')
                    }
                  }


                  setCreditCardValues(prev => ({ ...prev, credit_card_expiration: formattedValue }))

                  form.setFieldsValue({
                    credit_card_expiration: formattedValue,
                  });
                },
              },
            ]}
          // labelCol={{ span: 18 }}
          >
            <Input
              placeholder="MM/AA"
              maxLength={5}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Cód. de segurança"
            name="credit_card_verification_value"
            rules={[
              {
                required: true,
                message: 'Insira o código de segurança',
              },
              {
                validator: async (_, value) => {
                  let formattedValue = value
                    ?.replace(/\D+/g, "")
                    ?.slice(0, 3)

                  setCreditCardValues(prev => ({ ...prev, credit_card_verification_value: formattedValue }))

                  form.setFieldsValue({
                    credit_card_verification_value: formattedValue,
                  });
                },
              },
            ]}
          >
            <Input
              maxLength={3}
            />
          </Form.Item>
        </Col>


        <Col span={24}>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                width: '150px',
                float: 'left'
              }}
            >
              Salvar
            </Button>
          </Form.Item>
        </Col>

      </Row>

    </Col>
    <Col lg={12} span={0}>

      <div
        className='checkout-credit-card-preview'
      >
        <Space
          direction="vertical"
          style={{ width: '100%' }}
        >
          {/* <Typography className="m-0 checkout-credit-card-preview-title">
            {creditCardValues.credit_card_first_name} {creditCardValues.credit_card_last_name}
          </Typography> */}

          <div>
            <Typography className="m-0 checkout-credit-card-preview-title">
              NÚMERO DO CARTÃO
            </Typography>
            <strong>
              {creditCardValues.credit_card_number || '0000 0000 0000 0000'}
            </strong>
          </div>
          <Space
            size={60}
          >
            <div>
              <Typography className="m-0 checkout-credit-card-preview-title">
                Data
              </Typography>
              <strong>
                {creditCardValues.credit_card_expiration || '00/00'}
              </strong>
            </div>
            <div>
              <Typography className="m-0 checkout-credit-card-preview-title">
                CVV
              </Typography>
              <strong>{
                creditCardValues.credit_card_verification_value || '000'
              }</strong>
            </div>
          </Space>
        </Space>
      </div>
    </Col>
  </Row>

}

const PaymentDataView = ({ data, payments }) => {

  const course_payment_data = payments.find(item => (item.type === 2 && item.status === 'pending'))
  const price = course_payment_data ? course_payment_data[0]?.final_price : 0

  return (<>

    <Space
      direction="vertical"
      style={{ width: '100%', }}
    >

      <Title
        level={4}
        style={{ margin: 0, marginBottom: 12 }}
      >
        Dados do pagamento
      </Title>

      <img
        style={{
          width: '100%',
          maxWidth: '200px',
          height: '200px',
          display: 'block',
          margin: 'auto',
          borderRadius: '8px',
          objectFit: 'cover'
        }}
        src={`https://arboridiomas-api-stg.spheraedu.com/upload/courses/1925bbda24e5da09/TZi6bO08VEbAxqBGby4CQ4QirFqFeGmnbQOxe56e.png`}
        alt={data?.course?.name || 'Imagem do Curso'}
      />



      <Typography style={{ textAlign: 'center' }}>
        <strong>Curso:</strong>  {data?.course?.name}
      </Typography>

      <Space
        direction="vertical"
        style={{ width: '100%', marginTop: '1rem' }}
      >
        <Space
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          <Text
            style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.650)' }}
          >
            <strong>Comprador:</strong>   {data?.student_name}
          </Text>
          {/* 
          <Text
            style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.650)' }}

          >
            <strong>Emissão:</strong>  {data?.created_at}
          </Text> */}
        </Space>
        <Text
          style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.650)' }}
        >
          <strong>ID da Fatura:</strong>    {data?.hash}
        </Text>
      </Space>

      <Title level={3} style={{ margin: 0, marginTop: 12 }}>

        <strong>
          {data?.type}
        </strong>

      </Title>


      <Divider style={{ margin: 8 }} />
      <Typography>
        <strong>Total: {
          new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(parseFloat(price))
        }</strong>
      </Typography>

    </Space>


  </>)
}

export default function FinancialStatement() {
  const { profile, ...auth } = useAuth();
  const screens = useBreakpoint();
  const [loading, setLoading] = React.useState(false);
  const [form] = Form.useForm();

  const [contract, setContract] = React.useState(null);
  const [paymentData, setPaymentData] = React.useState(null);

  const list = paymentData?.data ?? [];

  const actionRef = React.useRef(null)

  const [contracts, setContracts] = React.useState([]);
  const [contractIsFetching, setContractIsFetching] = React.useState(false);

  const getContracts = async () => {

    setContractIsFetching(true);

    try {
      const { data: res } = await api.get(`/panel/student-enrollments/`);
      setContract({ ...res?.data[0], student_name: profile?.student_data?.name });
      setContracts(res?.data);
      return res.data;
    } catch (error) {
      console.log(error);
      error?.message ?? message.error(error.message);
    } finally {
      setContractIsFetching(false);
    }
  }


  const columns = [
    {
      title: "Titulo",
      dataIndex: "name",
      showSorterTooltip: false,
      render: (_, elm) => (
        <span style={{ textTransform: "capitalize" }}>{elm.name}</span>
      ),
    },
    {
      title: "Valor cheio",
      dataIndex: "price",
      showSorterTooltip: false,
      render: (_, elm) => (
        <span>
          {elm.practiced_value
            ? "R$" + elm.practiced_value
            : !!elm.price
              ? "R$" + elm.price
              : "N/A"}
        </span>
      ),
    },
    {
      title: "Valor da parcela",
      dataIndex: "installment_value",
      showSorterTooltip: false,
    },

    {
      title: "Qntd. Parcelas",
      dataIndex: "charges",
      showSorterTooltip: false,
      render: (_, elm) => <span>{elm?.charges}</span>,
    },
    {
      title: "Tipo de pagamento",
      dataIndex: "type",
      showSorterTooltip: false,
      render: (_, elm) => (
        <span>
          {payments[elm?.payment_method ?? elm?.product_payment_method]}
        </span>
      ),
    },
    {
      title: "Vencimento",
      dataIndex: "due_date",
      showSorterTooltip: false,
      render: (_, elm) => (
        <span>
          {elm?.due_date ? moment(elm?.due_date).format("DD/MM/YYYY") : "N/A"}
        </span>
      ),
    },

    {
      title: "Situação",
      dataIndex: "status",
      showSorterTooltip: false,
      render: (_, elm) => {


        return (
          <span style={{ textTransform: "capitalize" }}>

            <Tag color={colors[elm?.status] ?? 'blue'}>{elm?.status}</Tag>

          </span>
        )
      },
    },
    {
      title: "Ações",
      dataIndex: "action",
      showSorterTooltip: false,
      render: (_, elm) => (
        <>
          {elm.links && (
            <Popover
              overlayInnerStyle={{ padding: 0 }}
              content={<QRCode value={elm?.links?.qr_code} bordered={false} />}
            >
              <Tooltip title={!elm?.links?.qr_code && "Visualizar"}>
                <Button
                  type="link"
                  icon={<EyeOutlined />}
                  href={elm?.links?.url}
                  target="_blank"
                />
              </Tooltip>
            </Popover>
          )}
        </>
      ),
    },
  ];


  function renderCourses(courses) {

    return courses.map((course) => (
      <Select.Option key={course.id} value={course.id}>
        {course.team.code}
      </Select.Option>
    ));
  }

  const renderList = async (hash) => {
    setLoading(true);
    try {
      const { data } = await api.get(
        `/panel/student-enrollments/${hash}/payments/`
      );
      setPaymentData(data);

    } catch (error) {
      error.message && message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setContract(contracts.find((contract) => contract.id === +event));
  };

  useEffect(() => {
    getContracts();
  }, []);

  useEffect(() => {
    if (contract)
      renderList(contract.hash);

  }, [contract]);


  const [view, setView] = useState('credit-card-form');

  const [changePaymentMethodModalIsVisible, setChangePaymentMethodModalIsVisible] = useState(false);



  return (
    <Row
      style={{
        background: "#F5F7FA",
        padding: screens.md ? "10px 20px" : "16px 0",
        margin: 0
      }}
      gutter={[24, 24]}
      id="student-payments"
    >
      <Col span={24} order={2}>
        <ProCard>
          <div>
            {contracts && (
              <div
                style={{
                  display: "flex",
                  alignItems: screens.md ? "center" : "start",
                  flexDirection: !screens.md ? "column" : "row",
                  width: '100%',
                  gap: '10px'
                }}
              >
                <Title
                  level={5}
                  style={{
                    fontWeight: "bold",
                    margin: 0,
                  }}
                >
                  Contrato:
                </Title>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 10,
                    maxWidth: '500px',
                    width: '100%'

                  }}
                >
                  <Select
                    placeholder="Selecione o contrato"
                    style={{ width: "100%" }}
                    onChange={handleChange}
                  >
                    {contracts && renderCourses(contracts)}
                  </Select>
                  <Tooltip title="Recarregar">
                    <Button
                      type="primary"
                      icon={<ReloadOutlined />}
                      loading={contractIsFetching || loading}
                      onClick={() => {
                        if (contract) {
                          renderList(contract.hash);
                        }
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            )}
          </div>
        </ProCard>
      </Col>

      {(contractIsFetching || contract) && (
        <Col span={24} order={3}>
          <Card
            style={{
              padding: "24px",
            }}
          >
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",

              }}
            >
              <Col>
                <Title
                  level={5}
                  style={{
                    fontWeight: "bold",
                    margin: 0,
                    textTransform: "uppercase",
                  }}
                >
                  Pagamentos
                </Title>
              </Col>

              <Col>
                {paymentData?.meta?.can_change_to_credit_card && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setChangePaymentMethodModalIsVisible(true);
                    }}
                  >
                    Alterar forma de pagamento
                  </Button>
                )}
              </Col>



            </Row>
            <ProTable
              loading={loading}
              style={{
                marginBottom: "16px",
              }}
              tableStyle={{
                width: "100%",
                overflowX: "auto",
              }}
              
              columns={columns}
              dataSource={list}
              rowKey="hash"
              dateFormatter="string"

              search={false}
              pagination={{
                pageSize: 10,
                showSizeChanger: false,
                showQuickJumper: false,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} de ${total} itens`,
              }}
              options={{
                setting: false,
                search: false,
                reload: false,
                fullScreen: false,
                density: false,
              }}
              


              columnEmptyText=""
              actionRef={actionRef}
              onDataSourceChange={(data) => {
                message.success(
                  `Total de ${data.length} itens encontrados`
                );
              }}
              defaultData={[]}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<span>Nenhum pagamento encontrado</span>}
                  />
                ),
              }}
              bordered
            />

          </Card>
        </Col>
      )}

      <Modal
        open={changePaymentMethodModalIsVisible}
        onCancel={() => {
          setChangePaymentMethodModalIsVisible(false);
          form.resetFields();
        }}
        width={'850px'}
        bodyStyle={{
          height: '55vh',
          padding: '2rem 1rem',
          overflow: 'auto'
        }}

        cancelButtonProps={{
          style: {
            display: 'none'
          }
        }}
        okButtonProps={{
          style: {
            display: 'none'
          }
        }}
        className="toggle-payment-method-modal"
      >


        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Spin
              size="large"
              tip="Carregando..."
            />
          </div>
        ) : (
          <Form
            layout="vertical"
            onFinish={() => {



              form.validateFields().then(async (values) => {

                const credit_card = {
                  number: values?.credit_card_number?.replace(/\D/g, ""),
                  verification_value:
                    values?.credit_card_verification_value,
                  first_name: values?.credit_card_first_name,
                  last_name: values?.credit_card_last_name,
                  month: values?.credit_card_expiration?.split('/')[0],
                  year: values?.credit_card_expiration?.split('/')[1],
                };


                try {
                  setLoading(true);
                  await api.put(`/panel/student-enrollments/${contract.hash}/change-contract-payment-method/`, {
                    credit_card
                  });
                  message.success('Pagamento atualizado com sucesso!');
                  setChangePaymentMethodModalIsVisible(false);
                  form.resetFields();
                  renderList(contract.hash)
                } catch (error) {
                  message.error(error.message);
                } finally {
                  setLoading(false);

                }
              });
            }}
            form={form}
          >
            <Tooltip
              title={view === 'credit-card-form' ? 'Ver dados do pagamento' : 'Alterar forma de pagamento '}
            >
              <RightCircleTwoTone
                className="toggle-payment-method-modal-switch-view"
                onClick={() => {
                  setView((prev) => prev === 'credit-card-form' ? 'payment-data-view' : 'credit-card-form')
                }}
                rotate={
                  view === 'credit-card-form' ? 0 : 180
                }
                twoToneColor={'#dc6f10'}
              />
            </Tooltip>

            {view === 'credit-card-form' && <CreditCardForm payments={list} form={form} data={contract} loading={loading} />}
            {view === 'payment-data-view' && <PaymentDataView data={contract} payments={list} />}
          </Form>
        )}

      </Modal>
    </Row >

  );
}
